import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import GridColumn from "../GridColumn";

type Props = {
  asset: any,
  attributes: Array<any>,
  monetaryValues: Array<any>,
};

/**
 * Monetary Value Component
 */
export default ({ asset }: Props) => {
  const { typesList } = useSelector((state) => state);

  const assetMonetaryValues = useMemo(() => {
    const amountByTypeId = new Map(
      asset.monetaryValues.map((item) => [item.monetaryValueTypeId, item.amount])
    );
    return typesList.monetaryValueTypes.data
      .filter((item) => amountByTypeId.has(item.id))
      .map((item) => ({ name: item.name, amount: amountByTypeId.get(item.id) }));
  }, [asset.monetaryValues, typesList.monetaryValueTypes.data]);

  return (
    <>
      {assetMonetaryValues &&
        assetMonetaryValues.map((item, index) => (
          <GridColumn key={index} label={item.name} value={item.amount} />
        ))}
    </>
  );
};
